import { FunctionComponent } from 'react';

import Logo from 'components/layout/Logo';

import StyledComponent from './styles';
import { Props } from './types';

const WrapperPublicPlaceholderCover: FunctionComponent<Props> = () => ((
    <StyledComponent className="wrapper-public-placeholder-cover">
        <div className="wrapper-public-placeholder-cover__info-container">
            <div className="wrapper-public-placeholder-cover__info-container__logo">
                <Logo
                    width={240}
                    height={66}
                />
            </div>
            <div className="wrapper-public-placeholder-cover__info-container__title">
                Gruzilla - już wkrótce z Wami!
            </div>
        </div>
    </StyledComponent>
));

export default WrapperPublicPlaceholderCover;
